<app-header></app-header>
<div class="container-fluid site-content" style="padding-top: 0.4em">
  <router-outlet></router-outlet>
</div>
<app-footer style="padding-top: 1em"></app-footer>
<ngx-scrolltop size="50" theme="gray"></ngx-scrolltop>
